var map = {
	"./routing/index.js": 1194,
	"./translation/index.js": 1195
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;


//////////////////
// WEBPACK FOOTER
// ./src/app/runs index.js
// module id = 304
// module chunks = 0